import { createFileRoute } from "@tanstack/react-router";
import useFonts from "@/components/Fonts/useFonts";
import Results from "@/components/Results";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/results/$id")({
  component: ResultsPage,
});

function ResultsPage() {
  const { researchProjectId, id } = Route.useParams();
  useFonts();
  return <Results researchProjectId={Number.parseInt(researchProjectId)} id={id} />;
}
